export const sizeString = (data, sz) => {
    return `${data.substring(0, sz)}...`;
}
